import { all, takeEvery, takeLatest } from 'redux-saga/effects';

import * as actionTypes from '../actions/actionTypes';
import { stageSaga, updateSourceSaga } from './main';
import { fetchClientIdSaga } from './loadClientStyle';
import { fetchNRICSessionSaga } from './checkNRICSession';
import { fetchApplicationSaga } from './getApplication';
import submitApplicationSaga from './submitApplication';
import { uploadFileSaga } from './uploadFile';
import { fetchDropDownSaga } from './getDropDownData';
import { generateOTPSaga } from './generateOTP';
import { validateOTPSaga } from './validateOTP';
import { authorizeSingPassSaga, getMyInfoDataSaga, getMyInfoDataFailed } from './getMyInfoData';
import { getConsentsSaga } from './getConsents';
import { getConsentsPdfSaga } from './getConsentsPdf';

export function* watchSaga() {
    yield all([
        takeEvery(actionTypes.STAGE_UPDATE, stageSaga),
        takeEvery(actionTypes.UPDATE_SOURCE, updateSourceSaga),
        takeLatest(actionTypes.GET_DROPDOWN_DATA, fetchDropDownSaga),
        takeLatest(actionTypes.LOAD_CLIENT_STYLE, fetchClientIdSaga),
        takeLatest(actionTypes.CHECK_NRIC_SESSION, fetchNRICSessionSaga),
        takeLatest(actionTypes.GET_APPLICATION_DETAILS, fetchApplicationSaga),
        takeLatest(actionTypes.GENERATE_OTP, generateOTPSaga),
        takeLatest(actionTypes.SUBMIT_APPLICATION, submitApplicationSaga),
        takeLatest(actionTypes.UPLOAD_FILE, uploadFileSaga),
        takeLatest(actionTypes.VALIDATE_OTP, validateOTPSaga),
        takeLatest(actionTypes.GET_MYINFO_DATA, getMyInfoDataSaga),
        takeLatest(actionTypes.AUTHORIZE_MYINFO, authorizeSingPassSaga),
        takeLatest(actionTypes.GET_MYINFO_DATA_FAILED, getMyInfoDataFailed),
        takeLatest(actionTypes.GET_CONSENTS, getConsentsSaga),
        takeLatest(actionTypes.GET_CONSENTS_PDF, getConsentsPdfSaga),
    ]);
}
